type DocumentRecordLike = {
  uploaded_by?: string | null;
  status?: string | null;
};

export function canDeleteDocument(document: DocumentRecordLike, userId: string | null | undefined) {
  if (!userId || document.uploaded_by !== userId) {
    return false;
  }

  const status = (document.status || "pending").toLowerCase();
  return status === "pending" || status === "rejected";
}
